import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { GdprBannerComponent, GdprModalService } from '@mkp/gdpr/ui';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, switchMap, take, takeWhile } from 'rxjs';
import { tap } from 'rxjs/operators';
import { gdprModalActions } from '@mkp/gdpr/state/actions';

@Component({
  selector: 'mkp-gdpr-consent',
  imports: [GdprBannerComponent],
  templateUrl: './gdpr-consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GdprConsentComponent {
  private store = inject(Store);
  public gdprModalService = inject(GdprModalService);
  public gdprMessageType = toSignal(this.gdprModalService.gdprInitDisplay$);

  @HostBinding('class.gdpr-banner-offset') gdprBanner = false;
  constructor() {
    this.gdprModalService.gdprInitDisplay$
      .pipe(
        filter((display) => display === 'banner' || display === false),
        tap((display) => (this.gdprBanner = display === 'banner')),
        takeWhile((display) => display !== false)
      )
      .subscribe();

    // for Gdpr init: we display either a modal or a banner, the banner is set in the template
    this.showGdprInitModal();
  }
  onCloseBanner() {
    this.gdprModalService.saveCloseBannerCookie();
    this.gdprBanner = false;
  }

  onShowBanner() {
    this.gdprModalService.saveShowBannerCookie();
    this.store.dispatch(
      gdprModalActions.initGdprFromBanner({ gdpr: { functional: true, marketing: true } })
    );
  }

  private showGdprInitModal() {
    this.gdprModalService.gdprInitDisplay$
      .pipe(
        take(1),
        filter((gdprInitDisplay) => gdprInitDisplay === 'modal'),
        switchMap(() =>
          this.gdprModalService.openGdprDialog({
            action: gdprModalActions.initGdprFromModal,
            fullDetails: false,
          })
        )
      )
      .subscribe();
  }
}
